import React, { useEffect, useState } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import HomeIcon from '@mui/icons-material/Home';

import {
  Box,
  Button,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
} from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

const Sidebar = () => {
  const history = useHistory();
  const location = useLocation();

  const [showSideBar, setShowSideBar] = useState(false);
  const [showAll, setShowAll] = useState(false);

  const toggleDrawer = () => {
    setShowSideBar(!showSideBar);
  }

  const logout = () => {
    localStorage.clear();
    history.push('/login');
    setShowSideBar(false);
  }

  const goHome = () => {
    history.push('/first-step');
    setShowSideBar(false);
  }

  useEffect(() => {
    const { pathname } = location;
    if (pathname !== '/' && pathname !== '/login') { 
      setShowAll(true);
      return;
    }

    setShowAll(false);
  }, [location]);

  return (
    <>
      {showAll && (
        <>
          <Button
            onClick={() => { toggleDrawer(); }}
          >
            <MenuIcon sx={{ color: '#000000' }} />
          </Button>
          <Drawer
            anchor={'left'}
            open={showSideBar}
            onClose={() => { toggleDrawer() }}
          >
            <Box>
              <List>
                <ListItem>
                  <ListItemButton
                    onClick={() => { goHome() }}
                    sx={{ paddingLeft: '0px', gap: '10px' }}
                  >
                    <HomeIcon />
                    Inicio
                  </ListItemButton>
                </ListItem>
                <Divider />
                <ListItem>
                  <ListItemButton
                    onClick={() => { logout() }}
                    sx={{ paddingLeft: '0px', gap: '10px' }}
                  >
                    <LogoutIcon />
                    Sair
                  </ListItemButton>
                </ListItem>
              </List>
            </Box>
          </Drawer>
        </>
      )}
    </>
  );
}

export default Sidebar;
